import { ChangeEvent, LookupModelSearchEvent, DropdownSelectionEvent } from "@mcleod/components";
import { AutogenLayoutEscrowStatements } from "./autogen/AutogenLayoutEscrowStatements";

export class EscrowStatements  extends AutogenLayoutEscrowStatements  {
    onLoad(): void | Promise<void> {
        this.textboxGroupBy.setSelectedItemFromValue("P");
        this.excludabletextboxGLAccounts.switchRange.addChangeListener((event: ChangeEvent) => {
            const rangeStart = this.excludabletextboxGLAccounts.textboxRangeStart;
            const rangeEnd = this.excludabletextboxGLAccounts.textboxRangeEnd;
            const listener = this.textboxEscrowAccountstextboxBeforeLookupModelSearch;

            if (event.newValue) {
                rangeEnd.addBeforeLookupModelSearchListener(listener);
                rangeStart.addBeforeLookupModelSearchListener(listener);
            }
        });
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxEscrowAccounts-textbox. */
    textboxEscrowAccountstextboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
        event.filter.is_escrow = "Y";
    }

    /** This is an event handler for the beforeLookupModelSearch event of excludabletextboxPayees-textbox. */
    textboxBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.non_office_emp = 'Y';
    }

    /** This is an event handler for the onChange event of checkboxPageBreakAfterEachPayee. */
    checkboxPageBreakAfterEachPayeeOnChange(event: ChangeEvent) {
        if (event.newValue) {
            this.textboxGroupBy.setSelectedItemFromValue("P");
            this.checkboxPageBreakAfterEachEscrowAccount.checked = false;
        }
    }

    /** This is an event handler for the onChange event of checkboxPageBreakAfterEachEscrowAccount. */
    checkboxPageBreakAfterEachEscrowAccountOnChange(event: ChangeEvent) {
        if (event.newValue) {
            this.textboxGroupBy.setSelectedItemFromValue("A");
            this.checkboxPageBreakAfterEachPayee.checked = false;
        }
    }

    /** This is an event handler for the afterDropdownSelection event of textboxGroupBy. */
    textboxGroupByAfterDropdownSelection(event: DropdownSelectionEvent) {
        if (event.hasSelection()) {
            const selection = event.selection;
            if (selection.value === "P") {
                this.checkboxPageBreakAfterEachEscrowAccount.checked = false;
            }
            else {
                this.checkboxPageBreakAfterEachPayee.checked = false;
            }
        }
    }
}
